<template>
	<div class="margin-bottom18 flex-betweenCenter" :class="size ?'':'margin-top30'">
		<div class="weight700" :class="size?'font18':'font22'">{{title}}</div>
		<div v-if="more" class="flex-endCenter font16" :class="size?'color-grey9':'color-blue'" style="cursor: pointer;"
			@click="handleMore">
			{{more}} <i class="el-icon-arrow-right font16 margin-top2 weight600"
				:class="size ?'color-grey9':'color-blue'"></i>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'ComTitle',
		props: {
			title: {
				type: String,
				default: ''
			},
			more: {
				type: String,
				default: ''
			},
			size: {
				type: String,
				default: ''
			}

		},
		data() {
			return {
				keyWord: ''
			}
		},
		methods: {
			handleMore() {
				this.$emit('handleMore')
			}
		},
	}
</script>

<style lang="scss" scoped>
	.ComButton {
		cursor: pointer;

		&:hover {
			opacity: .8;
		}
	}
</style>